import { createReducer, on } from "@ngrx/store";
import * as InstallationActions from "./installation-actions";
import { InstallationStateInterface } from "src/app/installations/models/installationStateInterface";

export const initialState: InstallationStateInterface = {
    isLoading: false,
    installations: [],
    error: null,
};

export const installationReducers = createReducer(
    initialState, 

    // get Installations
    on(InstallationActions.getInstallations, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(InstallationActions.getInstallationsSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        installations: action.installations.slice().sort((a, b) => a.companyName?.localeCompare(b.companyName))
    })),
    on(InstallationActions.getInstallationsFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // get Installation by id
    on(InstallationActions.getInstallationById, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(InstallationActions.getInstallationByIdSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        activeInstallation: action.installation
    })),
    on(InstallationActions.getInstallationByIdFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // get Installations by company
    on(InstallationActions.getInstallationsByCompany, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(InstallationActions.getInstallationsByCompanySuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        installations: action.installations.slice().sort((a, b) => a.companyName?.localeCompare(b.companyName))
    })),
    on(InstallationActions.getInstallationsByCompanyFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // create Installation 
    on(InstallationActions.createInstallation, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(InstallationActions.createInstallationSuccess, (state, action) => {
        // Add the new Installation to the list of installations
        const updatedInstallations = [...state.installations, action.installation];
    
        // Sort installations by serial number, handling null values
        const sortedInstallations = updatedInstallations.sort((a, b) => {
            // If serial number is null, consider it as less than any non-null value
            const serialA = a.companyName || '';
            const serialB = b.companyName || '';
    
            // Compare serial numbers, treating empty strings as the lowest possible value
            return serialA.localeCompare(serialB);
        });
    
        return {
            ...state,
            isLoading: false,
            installations: sortedInstallations,
        };
    }),
    
    on(InstallationActions.createInstallationFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // update Installation
    on(InstallationActions.updateInstallation, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(InstallationActions.updateInstallationSuccess, (state, action) => {
        const updatedIndex = state.installations.findIndex(installation => installation.id === action.installation.id);
        
        if (updatedIndex === -1) {
            return state; // If product not found, return current state
        }

        const updated = [...state.installations];
        updated[updatedIndex] = action.installation;

        return {
            ...state,
            isLoading: false,
            installations: updated.sort((a, b) => a.companyName.localeCompare(b.companyName))
        };
    }),
    on(InstallationActions.updateInstallationFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // delete Installation
    on(InstallationActions.deleteInstallation, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(InstallationActions.deleteInstallationSuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        installations: state.installations.filter(installation => installation.id !== action.id)
      })),
    on(InstallationActions.deleteInstallationFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    }))
);